/**
 * Auth Guard Component - TEMPORARY PASS THROUGH
 * Version: 6.2.0
 */
import { Outlet } from 'react-router-dom'

export default function AuthGuard() {
  console.log('[AuthGuard] Rendering (pass-through mode)')
  return <Outlet />
}
